import { render, staticRenderFns } from "./MyGames.vue?vue&type=template&id=7b402340&scoped=true"
import script from "./MyGames.vue?vue&type=script&lang=js"
export * from "./MyGames.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b402340",
  null
  
)

export default component.exports